/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnInit} from '@angular/core';
import {LocalNetworkProfile} from '../../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-masq-banner',
  template: `
    <div class="warningBanner masqBanner clearfix" *ngIf="masq?.supportUserId || isSysNetwork">
      <div class="pull-right" style="position: relative; top: 4px">
        <ul class="list-inline">
          <li><a [uiSref]="'app.simple.supporting-pages'">Supporting Pages</a></li>
          <li><a [uiSref]="'app.simple.version-history'">Version History</a></li>
          <li><a [uiSref]="'app.simple.version-copy'">Version Copy</a></li>
        </ul>
      </div>
      <div>
        <span *ngIf="!isSysNetwork">You are {{ masq.supportUserId }} masquerading as <span style="border: 0; background-color: rebeccapurple; color: white;">{{ masq.username }}</span></span>&nbsp;
      </div>
    </div>
  `
})
export class MasqBannerComponent implements OnInit {
  @Input() masq: any;
  isSysNetwork = false;

  constructor(
    @Inject(LocalNetworkProfile) private LocalNetworkProfile: any
  ) {
  }

  ngOnInit(): void {
    this.isSysNetwork = this.LocalNetworkProfile.getNetworkTag() === '2';
  }
}
